export default "__VITE_ASSET__DE1wVxpu__"